import { PORTAL_TYPE } from '../../types/app.types';
import ErdeIcon from '../../../assets/ERDE_Prospect.png';
import Er1Icon from '../../../assets/ERDE_Client.png';
import UmerIcon from '../../../assets/ERDE_User.png';
import FmerIcon from '../../../assets/ERDE_Merchant.png';
import EbUserIcon from '../../../assets/EB_User.png';

export interface ButtonListDataItem {
  id: PORTAL_TYPE;
  img: string;
  link: string;
  redirectAddress?: string;
  formRootPage: PORTAL_TYPE;
}

export const buttonListData: ButtonListDataItem[] = [];

buttonListData.push({
  id: PORTAL_TYPE.ERDE,
  img: ErdeIcon,
  link: 'prospects',
  formRootPage: PORTAL_TYPE.ERDE
});

buttonListData.push({
  id: PORTAL_TYPE.ER1,
  img: Er1Icon,
  link: 'existing-client',
  formRootPage: PORTAL_TYPE.ER1
});

if (process.env.REACT_APP_LINK_UMER) {
  buttonListData.push({
    id: PORTAL_TYPE.UMER,
    img: UmerIcon,
    link: 'cardholders',
    redirectAddress: `${process.env.REACT_APP_LINK_UMER}`,
    formRootPage: PORTAL_TYPE.UMER
  });
}

if (process.env.REACT_APP_LINK_EBUSER) {
  buttonListData.push({
    id: PORTAL_TYPE.EBUSER,
    img: EbUserIcon,
    link: 'eb-user-contact-form',
    redirectAddress: `${process.env.REACT_APP_LINK_EBUSER}`,
    formRootPage: PORTAL_TYPE.EBUSER
  });
}

buttonListData.push({
  id: PORTAL_TYPE.FMER,
  img: FmerIcon,
  link: 'merchants',
  redirectAddress: `${process.env.REACT_APP_LINK_ERDE}`,
  formRootPage: PORTAL_TYPE.ERDE
});
